import { RfModal } from "@scripts/react/components/RfModal/RfModal";
import React, { useEffect, useState } from "react";
import { FloatingNavigationControls } from "@/components/shared/NavigationControls";
import { useKeyboardShortcut } from "@/hooks/useKeyboardShortcut";

interface FileModalProps {
    isOpen: boolean;
    fileUrl: string;
    fileName: string;
    isVideo: boolean;
    onClose: () => void;
    onPrevious?: () => void;
    onNext?: () => void;
}

export const FileModal = ({
    isOpen,
    fileUrl,
    fileName,
    isVideo,
    onClose,
    onPrevious,
    onNext
}: FileModalProps) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (isOpen) {
            setIsLoading(true);
        }
    }, [isOpen, fileUrl]);

    // Keyboard shortcuts for navigation
    useKeyboardShortcut({
        key: "ArrowLeft",
        handler: () => onPrevious?.(),
        disabled: !isOpen || !onPrevious
    });

    useKeyboardShortcut({
        key: "ArrowRight",
        handler: () => onNext?.(),
        disabled: !isOpen || !onNext
    });

    return (
        <RfModal isOpen={isOpen} onClose={onClose}>
            <RfModal.Overlay />
            <RfModal.Panel className="relative flex h-[90vh] !max-w-[90vw] items-center justify-center rounded-3xl p-4">
                {onPrevious && onNext && (
                    <FloatingNavigationControls onPrevious={onPrevious} onNext={onNext} />
                )}

                {isVideo && isLoading && (
                    <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                        <i className="far fa-spinner fa-spin text-lg text-tertiary" />
                    </div>
                )}

                {isVideo ? (
                    <video
                        src={fileUrl}
                        controls
                        autoPlay
                        className={`max-h-full max-w-full rounded-lg ${
                            isLoading ? "opacity-0" : "opacity-100"
                        } transition-opacity duration-200`}
                        onLoadedData={() => setIsLoading(false)}
                        onClick={(e) => e.stopPropagation()}
                    />
                ) : (
                    <img
                        src={fileUrl}
                        alt={fileName}
                        className="max-h-full max-w-full rounded-lg object-contain"
                        onLoad={() => setIsLoading(false)}
                        onClick={(e) => e.stopPropagation()}
                    />
                )}
            </RfModal.Panel>
        </RfModal>
    );
};
